import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { saveAs } from "file-saver"; // Ensure file-saver is installed
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  handleUnauthorized,
  showConfirmationDialog,
} from "../../utils/apiHelper";
const SpaceListLayerNew = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Dynamically adjustable items per page
  const [selectedItems, setSelectedItems] = useState([]); // Track selected items
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [roletype, setRoleType] = useState("pending");
  const authToken = localStorage.getItem("authToken");
  const [showModal, setShowModal] = useState(false);
  const [rejectresone, setRejectResone] = useState("");
  const [selectedExport, setSelectedExport] = useState("");
  const [errors, setErrors] = useState({});
  const [rejectId, setRejectId] = useState("");

  useEffect(() => {
    fetchData(currentPage, roletype);
  }, [currentPage, searchQuery, itemsPerPage, sortOrder, sortColumn, roletype]);

  const tabChange = (tabName) => {
    setCurrentPage(1);
    setRoleType(tabName);
  };
  const closeModel = () => {
    setShowModal(false);
  };

  const validateInputs = () => {
    const newErrors = {};
    if (rejectresone.trim() === "") {
      newErrors.rejectresone = "Reason is required";
    }
    if (!rejectresone) newErrors.rejectresone = "Reason is required";
    setErrors(newErrors);
    if (rejectresone) {
      if (!/^[A-Za-z\s]+$/.test(rejectresone)) {
        rejectresone.rejectresone = "Reason must contain only alphabets";
      }
      if (rejectresone.length < 3) {
        newErrors.rejectresone = "Reason must be at least 3 characters long";
      }
    }
    return Object.keys(newErrors).length === 0;
  };

  const fetchData = async (page, roletype) => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/storageSpaceList?page=${page}&limit=${itemsPerPage}&sort=${sortColumn}&order=${sortOrder}&search=${searchQuery}&storageStatus=${roletype}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setItems(data.storageSpaces || []);
      setTotalItems(data.metadata.totalItems || 0);
      setTotalPages(data.metadata.totalPages || 1);
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  const handleExportChange = (event) => {
    const exportType = event.target.value;
    setSelectedExport(exportType);
    if (exportType === "csv") {
      const dataToExport =
        selectedItems.length > 0
          ? items.filter((item) => selectedItems.includes(item._id))
          : items;
      if (dataToExport.length === 0) {
        setErrorMessage("No data available to export.");
        return;
      }
      const csvData = dataToExport.map((item) => ({
        Title: item.title || "N/A",
        "Price($)": item.price || "N/A",
        HostName: item.hostName || "N/A",
        Location: item.address || "N/A",
        Date: new Date(item.createdAt).toLocaleDateString(),
        Status:
          item.status.charAt(0).toUpperCase() + item.status.slice(1) || "N/A",
      }));
      const csv = Papa.unparse(csvData);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `storagespace_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    if (exportType === "excel") {
      const dataToExport =
        selectedItems.length > 0
          ? items.filter((item) => selectedItems.includes(item._id))
          : items;
      if (dataToExport.length === 0) {
        setErrorMessage("No data available to export.");
        return;
      }
      const excelData = dataToExport.map((item) => ({
        Title: item.title || "N/A",
        "Price($)": item.price || "N/A",
        HostName: item.hostName || "N/A",
        Location: item.address || "N/A",
        Date: new Date(item.createdAt).toLocaleDateString(),
        Status:
          item.status.charAt(0).toUpperCase() + item.status.slice(1) || "N/A",
      }));
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Storage Space");
      XLSX.writeFile(
        workbook,
        `storagespace_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    }
    if (exportType === "pdf") {
      const dataToExport =
        selectedItems.length > 0
          ? items.filter((item) => selectedItems.includes(item._id))
          : items;

      if (dataToExport.length === 0) {
        setErrorMessage("No data available to export.");
        return;
      }

      const pdf = new jsPDF();
      pdf.setFontSize(18);
      pdf.text("Renter Report", 14, 15);
      const headers = [
        "Name",
        "Price($)",
        "HostName",
        "Location",
        "Status",
        "Date",
      ];
      const rows = dataToExport.map((item) => [
        item.title || "N/A",
        item.price || "N/A",
        item.hostName || "N/A",
        item.address || "N/A",
        item.status.charAt(0).toUpperCase() + item.status.slice(1) || "N/A",
        new Date(item.createdAt).toLocaleDateString(),
      ]);
      autoTable(pdf, {
        head: [headers],
        body: rows,
        headStyles: {
          fillColor: "#d83d76",
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        startY: 25,
      });
      pdf.save(`renter_${new Date().toISOString().slice(0, 10)}.pdf`);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };
  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };
  const updateStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    const message = `Do you want to change the status to ${newStatus}?`;
    const result = await showConfirmationDialog(message);
    if (result.isConfirmed) {
      try {
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/storageSpaceUpdate/${id}`;
        const response = await fetch(API_ENDPOINT, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ status: newStatus }),
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setSuccessMessage("Storage Space status updated successfully!");
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);

        fetchData(currentPage, roletype);
      } catch (error) {
        setErrorMessage(error.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
    }
  };
  const updateStorageStatus = async (id, currentStatus) => {
    let newStatus;
    if (currentStatus === "reject") {
      newStatus = "rejected";
    } else {
      newStatus = currentStatus;
    }
    const message = `Do you want to change the status to ${currentStatus}?`;
    if (currentStatus === "reject") {
      if (!showModal) {
        setRejectId(id);
        setShowModal(true);
        return;
      }
      if (!validateInputs()) {
        setLoading(false);
        return;
      }
    }
    let result = { isConfirmed: false };
    if (currentStatus != "reject") {
      result = await showConfirmationDialog(message);
    } else {
      result = { isConfirmed: true };
    }
    if (!result.isConfirmed) return;
    if (result.isConfirmed) {
      try {
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/updateStorageStatus/${id}`;
        const response = await fetch(API_ENDPOINT, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            storageStatus: newStatus,
            reason: rejectresone,
          }),
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setRejectResone("");
        setShowModal(false);
        setSuccessMessage(`Storage status ${newStatus} successfully!`);
        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);

        fetchData(currentPage, roletype);
      } catch (error) {
        setErrorMessage(error.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
    }
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(items.map((item) => item.id));
    } else {
      setSelectedItems([]);
    }
  };
  const storedPermissions = JSON.parse(
    localStorage.getItem("permissions") || "[]"
  );
  const hostIndividualPermissions = storedPermissions.find(
    (perm) => perm.moduleName === "Storage Space"
  );
  const canView = hostIndividualPermissions?.view || false;
  const canDelete = hostIndividualPermissions?.delete || false;
  const canEdit = hostIndividualPermissions?.edit || false;
  const userrole = localStorage.getItem("user_role");

  const shouldCheckPermissions = userrole === "support_admin";
  const getPaginationRange = () => {
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };
  const handleSelectItem = (id) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((item) => item !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  const isSelected = (id) => selectedItems.includes(id);
  const handleDeleteAll = async (id, single = "No") => {
    const idsToDelete = single === "Yes" ? [id] : selectedItems;
    if (idsToDelete.length === 0) {
      return;
    }
    if (idsToDelete.length == 1) {
      single = "Yes";
    }
    const message = `This action will delete the Storage Space!`;
    const confirmmessage = `Yes, delete it!`;
    const result = await showConfirmationDialog(message, confirmmessage);

    if (!result.isConfirmed) return;

    try {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/storageSpaceDelete`;
      const response = await fetch(API_ENDPOINT, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ id: idsToDelete }),
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const successmessage =
        single === "Yes"
          ? "Storage Space deleted successfully!"
          : "Storage Space deleted successfully!";
      setSuccessMessage(successmessage);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      if (single === "No") {
        setSelectedItems([]);
      }
      fetchData(currentPage);
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
  };
  return (
    <div className="card h-100 p-0 radius-12">
      <ul
        className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
        id="pills-tab"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            className="nav-link d-flex align-items-center px-24 active"
            id="pending-tab"
            data-bs-toggle="pill"
            data-bs-target="#pending-space"
            type="button"
            role="tab"
            aria-controls="pending-space"
            aria-selected="false"
            tabIndex={-1}
            onClick={() => tabChange("pending")}
          >
            Pending Space
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link d-flex align-items-center px-24 "
            id="approve-tab"
            data-bs-toggle="pill"
            data-bs-target="#approve-space"
            type="button"
            role="tab"
            aria-controls="approve-space"
            aria-selected="true"
            onClick={() => tabChange("approved")}
          >
            Approved Space
          </button>
        </li>

        <li className="nav-item" role="presentation">
          <button
            className="nav-link d-flex align-items-center px-24"
            id="reject-tab"
            data-bs-toggle="pill"
            data-bs-target="#reject-space"
            type="button"
            role="tab"
            aria-controls="reject-space"
            aria-selected="false"
            tabIndex={-1}
            onClick={() => tabChange("rejected")}
          >
            Reject Space
          </button>
        </li>
      </ul>
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className="text-md fw-medium text-secondary-light mb-0">
            Show
          </span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={itemsPerPage}
            defaultValue="Select Number"
            onChange={handleItemsPerPageChange}
          >
            <option value="10">10 items per page</option>
            <option value="20">20 items per page</option>
            <option value="50">50 items per page</option>
            <option value="100">100 items per page</option>
          </select>
          <form className="navbar-search">
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              name="search"
              placeholder="Search by Title or Price"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={(e) => {
                if (e.target.value === "") {
                  setCurrentPage(1);
                }
              }}
            />
            <Icon icon="ion:search-outline" className="icon" />
            {searchQuery && (
              <button
                onClick={() => {
                  setSearchQuery("");
                  setCurrentPage(1);
                }}
                style={{
                  position: "absolute",
                  insetInlineEnd: "1.9375rem",
                  top: "40%",
                  transform: "translateY(-50%)",
                  fontSize: "1.125rem",
                  color: "var(--black)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Icon icon="ic:round-close" />
              </button>
            )}
          </form>
          {(!shouldCheckPermissions || canDelete) && (
            <button
              className="btn btn-danger"
              onClick={handleDeleteAll}
              disabled={selectedItems.length === 0}
            >
              Delete All
            </button>
          )}
        </div>
      </div>
      <div className="card-body p-24">
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pending-space"
            role="tabpanel"
            aria-labelledby="pending-tab"
            tabIndex="0"
          >
            <div className="table-responsive scroll-sm">
              <table className="table bordered-table sm-table mb-0">
                <thead>
                  <tr>
                    {(!shouldCheckPermissions || canDelete) && (
                      <th scope="col">
                        <div className="d-flex align-items-center gap-10">
                          <div className="form-check style-check d-flex align-items-center">
                            <input
                              className="form-check-input radius-4 border input-form-dark"
                              type="checkbox"
                              name="checkbox"
                              id="selectAll"
                              onChange={handleSelectAll}
                              checked={
                                selectedItems.length === items.length &&
                                items.length > 0
                              }
                            />
                          </div>
                        </div>
                      </th>
                    )}

                    <th
                      onClick={() => handleSort("title")}
                      style={{ cursor: "pointer" }}
                    >
                      Title
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "title" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "title" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("price")}
                      style={{ cursor: "pointer" }}
                    >
                      Price($){" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "price" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "price" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("host.businessName")}
                      style={{ cursor: "pointer" }}
                    >
                      HostName{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("address")}
                      style={{ cursor: "pointer" }}
                    >
                      Location{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "address" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "address" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("createdAt")}
                      style={{ cursor: "pointer" }}
                    >
                      Date{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="loader-15"></span>
                      </td>
                    </tr>
                  ) : items.length > 0 ? (
                    items.map((item, index) => (
                      <tr key={item.id}>
                        {(!shouldCheckPermissions || canDelete) && (
                          <td>
                            <div className="d-flex align-items-center gap-10">
                              <div className="form-check style-check d-flex align-items-center">
                                <input
                                  className="form-check-input radius-4 border border-neutral-400"
                                  type="checkbox"
                                  name="checkbox"
                                  value={item.id}
                                  checked={isSelected(item.id)}
                                  onChange={() => handleSelectItem(item.id)}
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.title || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.price || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.hostName || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.address || "N/A"}
                          </span>
                        </td>
                        <td>
                          {(() => {
                            const date = new Date(item.createdAt);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are 0-indexed
                            const year = String(date.getFullYear());
                            return `${day}-${month}-${year}`;
                          })()}
                        </td>

                        <td>
                          <span
                            onClick={() => updateStatus(item.id, item.status)}
                            className={`${item.status === "active"
                              ? "bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                              : item.status === "inactive"
                                ? "bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                                : "bg-warning"
                              }`}
                            style={{ cursor: "pointer" }}
                          >
                            {item.status.charAt(0).toUpperCase() +
                              item.status.slice(1)}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-10">
                            {(!shouldCheckPermissions || canView) && (
                              <button
                                type="button"
                                title="View"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/view-storagespace/${item.id}`
                                  )
                                }
                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="majesticons:eye-line"
                                  className="icon text-xl"
                                />
                              </button>
                            )}

                            {(!shouldCheckPermissions || canDelete) && (
                              <button
                                type="button"
                                title="Delete"
                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => handleDeleteAll(item.id, "Yes")}
                              >
                                <Icon
                                  icon="fluent:delete-24-regular"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            {(!shouldCheckPermissions || canEdit) && (
                              <button
                                title="Edit"
                                type="button"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/edit-storagespace/${item.id}`
                                  )
                                }
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="lucide:edit"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            <button
                              title="Approve"
                              type="button"
                              className="remove-item-btn bg-success-focus bg-hover-success-200 text-success-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() =>
                                updateStorageStatus(item.id, "approved")
                              }
                            >
                              <Icon
                                icon="lucide:circle-check"
                                className="menu-icon"
                              />
                            </button>
                            <button
                              type="button"
                              title="Reject"
                              className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() =>
                                updateStorageStatus(item.id, "reject")
                              }
                            >
                              <Icon
                                icon="lucide:circle-x"
                                className="menu-icon"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className="tab-pane fade "
            id="approve-space"
            role="tabpanel"
            aria-labelledby="approve-tab"
            tabIndex={0}
          >
            <div className="table-responsive scroll-sm">
              <table className="table bordered-table sm-table mb-0">
                <thead>
                  <tr>
                    {(!shouldCheckPermissions || canDelete) && (
                      <th scope="col">
                        <div className="d-flex align-items-center gap-10">
                          <div className="form-check style-check d-flex align-items-center">
                            <input
                              className="form-check-input radius-4 border input-form-dark"
                              type="checkbox"
                              name="checkbox"
                              id="selectAll"
                              onChange={handleSelectAll}
                              checked={
                                selectedItems.length === items.length &&
                                items.length > 0
                              }
                            />
                          </div>
                        </div>
                      </th>
                    )}

                    <th
                      onClick={() => handleSort("title")}
                      style={{ cursor: "pointer" }}
                    >
                      Title
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "title" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "title" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("price")}
                      style={{ cursor: "pointer" }}
                    >
                      Price($){" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "price" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "price" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("host.businessName")}
                      style={{ cursor: "pointer" }}
                    >
                      HostName{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("address")}
                      style={{ cursor: "pointer" }}
                    >
                      Location{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "address" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "address" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("createdAt")}
                      style={{ cursor: "pointer" }}
                    >
                      Date{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="loader-15"></span>
                      </td>
                    </tr>
                  ) : items.length > 0 ? (
                    items.map((item, index) => (
                      <tr key={item._id}>
                        {(!shouldCheckPermissions || canDelete) && (
                          <td>
                            <div className="d-flex align-items-center gap-10">
                              <div className="form-check style-check d-flex align-items-center">
                                <input
                                  className="form-check-input radius-4 border border-neutral-400"
                                  type="checkbox"
                                  name="checkbox"
                                  value={item.id}
                                  checked={isSelected(item.id)}
                                  onChange={() => handleSelectItem(item.id)}
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.title || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.price || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.hostName || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.address || "N/A"}
                          </span>
                        </td>

                        <td>
                          {(() => {
                            const date = new Date(item.createdAt);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are 0-indexed
                            const year = String(date.getFullYear());
                            return `${day}-${month}-${year}`;
                          })()}
                        </td>

                        <td>
                          <span
                            onClick={() => updateStatus(item.id, item.status)}
                            className={`${item.status === "active"
                              ? "bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                              : item.status === "inactive"
                                ? "bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                                : "bg-warning"
                              }`}
                            style={{ cursor: "pointer" }} // Add cursor pointer for better UX
                          >
                            {item.status.charAt(0).toUpperCase() +
                              item.status.slice(1)}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-10">
                            {(!shouldCheckPermissions || canView) && (
                              <button
                                type="button"
                                title="View"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/view-storagespace/${item.id}`
                                  )
                                }
                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="majesticons:eye-line"
                                  className="icon text-xl"
                                />
                              </button>
                            )}

                            {(!shouldCheckPermissions || canDelete) && (
                              <button
                                type="button"
                                title="Delete"
                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => handleDeleteAll(item.id, "Yes")}
                              >
                                <Icon
                                  icon="fluent:delete-24-regular"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            {(!shouldCheckPermissions || canEdit) && (
                              <button
                                type="button"
                                title="Edit"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/edit-storagespace/${item.id}`
                                  )
                                }
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="lucide:edit"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            <button
                              type="button"
                              title="Reject"
                              className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() =>
                                updateStorageStatus(item.id, "reject")
                              }
                            >
                              <Icon
                                icon="lucide:circle-x"
                                className="menu-icon"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className="tab-pane fade show"
            id="reject-space"
            role="tabpanel"
            aria-labelledby="reject-tab"
            tabIndex={0}
          >
            <div className="table-responsive scroll-sm">
              <table className="table bordered-table sm-table mb-0">
                <thead>
                  <tr>
                    {(!shouldCheckPermissions || canDelete) && (
                      <th scope="col">
                        <div className="d-flex align-items-center gap-10">
                          <div className="form-check style-check d-flex align-items-center">
                            <input
                              className="form-check-input radius-4 border input-form-dark"
                              type="checkbox"
                              name="checkbox"
                              id="selectAll"
                              onChange={handleSelectAll}
                              checked={
                                selectedItems.length === items.length &&
                                items.length > 0
                              }
                            />
                          </div>
                        </div>
                      </th>
                    )}

                    <th
                      onClick={() => handleSort("title")}
                      style={{ cursor: "pointer" }}
                    >
                      Title
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "title" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "title" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("price")}
                      style={{ cursor: "pointer" }}
                    >
                      Price($){" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "price" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "price" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("host.businessName")}
                      style={{ cursor: "pointer" }}
                    >
                      HostName{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "host.businessName" &&
                            sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("address")}
                      style={{ cursor: "pointer" }}
                    >
                      Location{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "address" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "address" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th
                      onClick={() => handleSort("createdAt")}
                      style={{ cursor: "pointer" }}
                    >
                      Date{" "}
                      <span className="sort-colume">
                        <Icon
                          icon="mdi:arrow-up"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "asc"
                            ? "active"
                            : ""
                            }`}
                        />
                        <Icon
                          icon="mdi:arrow-down"
                          className={`arrow ${sortColumn === "createdAt" && sortOrder === "desc"
                            ? "active"
                            : ""
                            }`}
                        />
                      </span>
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="loader-15"></span>
                      </td>
                    </tr>
                  ) : items.length > 0 ? (
                    items.map((item, index) => (
                      <tr key={item._id}>
                        {(!shouldCheckPermissions || canDelete) && (
                          <td>
                            <div className="d-flex align-items-center gap-10">
                              <div className="form-check style-check d-flex align-items-center">
                                <input
                                  className="form-check-input radius-4 border border-neutral-400"
                                  type="checkbox"
                                  name="checkbox"
                                  value={item._id}
                                  checked={isSelected(item._id)}
                                  onChange={() => handleSelectItem(item._id)}
                                />
                              </div>
                            </div>
                          </td>
                        )}
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.title || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.price || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.hostName || "N/A"}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.address || "N/A"}
                          </span>
                        </td>
                        <td>
                          {(() => {
                            const date = new Date(item.createdAt);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are 0-indexed
                            const year = String(date.getFullYear());
                            return `${day}-${month}-${year}`;
                          })()}
                        </td>

                        <td>
                          <span
                            onClick={() => updateStatus(item.id, item.status)}
                            className={`${item.status === "active"
                              ? "bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                              : item.status === "inactive"
                                ? "bg-neutral-200 text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                                : "bg-warning"
                              }`}
                            style={{ cursor: "pointer" }} // Add cursor pointer for better UX
                          >
                            {item.status.charAt(0).toUpperCase() +
                              item.status.slice(1)}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex align-items-center gap-10">
                            {(!shouldCheckPermissions || canView) && (
                              <button
                                title="View"
                                type="button"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/view-storagespace/${item.id}`
                                  )
                                }
                                className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="majesticons:eye-line"
                                  className="icon text-xl"
                                />
                              </button>
                            )}

                            {(!shouldCheckPermissions || canDelete) && (
                              <button
                                type="button"
                                title="Delete"
                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => handleDeleteAll(item.id, "Yes")}
                              >
                                <Icon
                                  icon="fluent:delete-24-regular"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            {(!shouldCheckPermissions || canEdit) && (
                              <button
                                title="Edit"
                                type="button"
                                onClick={() =>
                                  navigate(
                                    `/storage-space/edit-storagespace/${item.id}`
                                  )
                                }
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              >
                                <Icon
                                  icon="lucide:edit"
                                  className="menu-icon"
                                />
                              </button>
                            )}
                            <button
                              title="Approve"
                              type="button"
                              className="remove-item-btn bg-success-focus bg-hover-success-200 text-success-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() =>
                                updateStorageStatus(item.id, "approved")
                              }
                            >
                              <Icon
                                icon="lucide:circle-check"
                                className="menu-icon"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handlePrev}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>
            {getPaginationRange().map((page) => {
              return (
                <li key={page} className="page-item">
                  <Link
                    className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${currentPage === page
                      ? "bg-primary-600 text-white"
                      : "bg-neutral-200"
                      }`}
                    to="#"
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Link>
                </li>
              );
            })}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handleNext}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        class={`custom-modal modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                Reject Reason
              </h5>
            </div>
            <div class="modal-body">
              <form className="row gy-3 needs-validation" noValidate>
                <div className="col-md-12">
                  <label className="form-label">Reason</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="answer"
                    cols="4"
                    rows="5"
                    value={rejectresone}
                    placeholder="Enter Reason"
                    onChange={(e) => {
                      setRejectResone(e.target.value);
                      setErrors((prev) => ({ ...prev, rejectresone: "" }));
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/\s{2,}/g, " ")
                        .trimStart();
                    }}
                  />
                  {errors.rejectresone && (
                    <p className="text-danger mt-1">{errors.rejectresone}</p>
                  )}
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeModel()}
              >
                Close
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                onClick={() => updateStorageStatus(rejectId, "reject")}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpaceListLayerNew;
